import { Box, Button } from '@mui/material'
import Datepicker from '../../../common/datePicker'
import DropDownOA from '../../../common/dropDownOA'
import { Item } from '../../../common/snippets'
import { SplitButton } from '../../../common/SplitButton'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { RefreshSvg } from '../../../common/svg/refresh'
import { ReportHeading } from '../common/ReportHeading'
import { useState } from 'react'
import moment from 'moment/moment'
import { appendToUrl, buildCompositeFields, clickElement, focusElemnt, getInt, getLocalData, navigation3 } from '../../../common/helper'
import { useEffect } from 'react'
import * as urls2 from '../oldReportsUrls'
import { detailedTblColDefs, groupDataDetailed, groupDataDetailedSummary, partyAsList, summaryTblColDefs, partyBookingSummaryHeader, transformPartyBookingSummary } from './const'
import * as mdt from '../../../common/modaltypes'
import ManageColumns from '../../../common/ManageColumnsUI'
import { useAtom, useAtomValue, useSetAtom } from 'jotai'
import { CargoRoleRightsAtom, companySettingsAtom } from '../../../common/jotaiState/commonStateAtoms'
import { alertAtom, globalLoaderAtom, modalAtom } from '../../../common/jotaiState/globalStateAtoms'
import useToken from '../../../helpers/useTokens'
import { GetRequest } from '../../../common/api'
import { urls } from '../../../common/constants'
import { TOPAY_COD_RULE, TOPAY_COD_RULE2 } from '../../../common/paymentsMode'
import { useDispatch } from 'react-redux'
import { updateAlertError } from '../../../../store/common/common_action'
import { useSearchParams } from 'react-router-dom'
import { downloadPDF, downloadMultiTablePDF } from '../../Reports/analysisReport/pdfAutotable'
import { GAJRAJ } from '../../../../helper/companyIdhardcode'
const PartyBookingReport = () => {
  const [modal, setModal] = useAtom(modalAtom)
  const setLoader = useSetAtom(globalLoaderAtom)
  const setAlert = useSetAtom(alertAtom)
  const dispatch = useDispatch()
  const reportName = 'Party Booking'
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [bookingTypeDropdown, setBookingTypeDropdown] = useState([])
  const [cityDropdown, setCityDropdown] = useState([])
  const [partyDropdown, setPartyDropdown] = useState([])
  const [pymtModeDropdown, setPymtModeDropdown] = useState([])
  const [companyDropdown, setCompanyDropdown] = useState([])
  const [partyAsId, setPartyAsId] = useState(partyAsList[0]?.id)
  const [party, setParty] = useState('')
  const [bookingMode, setBookingMode] = useState('')
  const [paymentMode, setPaymentMode] = useState('')
  const [partyCity, setPartyCity] = useState('')
  const reportViewList = [
    { id: 0, name: 'Detailed' },
    { id: 1, name: 'Summary' },
  ]
  const [isExpanded, setIsExpanded] = useState(false)
  const [reportView, setReportView] = useState(reportViewList?.[0])
  const [resetFilter, setResetFilter] = useState(false)
  const [companyName, setCompanyName] = useState('')
  const [manageColumn, setManageColumn] = useState([])
  const [smryRptHeading, setSmryRptHeading] = useState('')
  
  const [companySettings] = useAtom(companySettingsAtom)
  const [cargoRoleRights] = useAtom(CargoRoleRightsAtom)
  const { Table1: RoleRightTable1 = [] } = cargoRoleRights
  const [roleRightsData] = RoleRightTable1
  let { AllowViewAllBranchReport, AllowBranchInchargeRights, AllowExportExcel } = { ...roleRightsData }
  const [searchParams] = useSearchParams()
  const UseFormattedLRinReports = companySettings?.UseFormattedLRinReports  
  const UseToPayAsCOD = companySettings?.UseToPayAsCOD
  const IsPartyBookingPortrait = companySettings?.IsPartyBookingPortrait

  let { loginData = {} } = useToken()
  let isFromUrl = false
  if (!loginData) {
    loginData = {}
    loginData.intCompanyID = searchParams.get('C') || 0
    loginData.intBranchCityID = searchParams.get('CT') || 0
    loginData.intUserID = searchParams.get('U') || 0
    loginData.intBranchID = searchParams.get('B') || 0
    loginData.strUserName = searchParams.get('UN') || ''
    loginData.strCompanyName = searchParams.get('CN') || ''
    loginData.strBranchName = searchParams.get('BN') || ''
    isFromUrl = true
  }
  let { DefaultCurrencyID } = companySettings
  if (!DefaultCurrencyID) {
    DefaultCurrencyID = +searchParams.get('DC') || 1
  }

  const { intCompanyID, IsAdmin, intBranchID, intBranchCityID, intUserID, strCompanyName, strCityName, IsBranchAdmin, IsMTPLAdmin } = loginData
  const enableBranchChange = AllowViewAllBranchReport || AllowBranchInchargeRights || IsBranchAdmin || IsMTPLAdmin || IsAdmin
  const isGajraj = [GAJRAJ].includes(intCompanyID);

  const criteriaHeaders = [
    { field: 'companyName', header: 'Company', textAlign: 'left' },
    { field: 'paymentMode', header: 'Payment Mode', textAlign: 'left' },
    { field: 'partyCity', header: 'City', textAlign: 'left' },
    { field: 'party', header: 'Party', textAlign: 'left' },
    { field: 'partyAs', header: 'Show Party AS', textAlign: 'left' },
  ]
  const criteriaData = {
    companyName: companyName || '',
    paymentMode: paymentMode?.name || '',
    partyCity: partyCity?.name || ``,
    party: party?.name || '',
    partyAs: party?.name || '',
    dataType: 'entry',
  }

  useEffect(() => {
    if (reportView.id === 0) {
      if (partyAsId === 0) {
        setSmryRptHeading('Both Sender & Receiver Party Details')
      } else if (partyAsId === 1) {
        setSmryRptHeading('Sender Party Details')
      } else if (partyAsId === 2) {
        setSmryRptHeading('Receiver Party Details')
      } else if (partyAsId === 3) {
        setSmryRptHeading('Payment Responsibility Party Details')
      }
    } else {
      if (partyAsId === 0) {
        setSmryRptHeading('Sender Party Summary')
      } else if (partyAsId === 1) {
        setSmryRptHeading('Sender Party Summary')
      } else if (partyAsId === 2) {
        setSmryRptHeading('Receiver Party Summary')
      } else if (partyAsId === 3) {
        setSmryRptHeading('Payment Responsibility Party Summary')
      }
    }
  }, [partyAsId])

  const updateHeaders = async () => {
    let headers = await getLocalData('partyReportDetailed')
    if (!headers) {
      headers = detailedTblColDefs
    }
    const keysToRemove =
      UseFormattedLRinReports === 3
        ? [detailedTblColDefs[2].dataKey]
        : UseFormattedLRinReports === 2
          ? [detailedTblColDefs[1].dataKey, detailedTblColDefs[3].dataKey]
          : [detailedTblColDefs[2].dataKey, detailedTblColDefs[3].dataKey]
    headers = headers.filter(({ dataKey }) => !keysToRemove.includes(dataKey))
    if (IsPartyBookingPortrait) {
      headers = headers.filter((item) => item.isMandatory === true)
    }
    if (DefaultCurrencyID === 2) {
      headers = headers
        .filter((val) => !['DeliveryGST', 'BookingGST'].includes(val.dataKey))
        .map((val) => {
          if (val.dataKey === 'SenderGSTN^^SenderEmailID') {
            return { ...val, header: 'Sndr. eMail', exportHead: 'Sender Email', dataKey: 'SenderEmailID' }
          }
          if (val.dataKey === 'ReceiverGSTN^^ReceiverEmailID') {
            return { ...val, header: 'Rcvr. eMail', exportHead: 'Receiver Email', dataKey: 'ReceiverEmailID' }
          }
          if (val.dataKey === 'Valuation') {
            return { ...val, header: 'Insurance', exportHead: 'Insurance' }
          }
          return val
        })
    }
    setManageColumn(headers)
  }

  useEffect(() => {
    updateHeaders()
  }, [DefaultCurrencyID, UseFormattedLRinReports, IsPartyBookingPortrait])

  useEffect(() => {
    focusElemnt('prtyBkngFromDate')
  }, [])

  useEffect(() => {
    if (loginData) {
      var company = [{ id: intCompanyID, name: strCompanyName }]
      setCompanyDropdown(company)
      setCompanyName(strCompanyName)
    }
  }, [intCompanyID])

  const filterConfig = {
    bookingType: { id: 'PaymentTypeInt', name: 'PaymentType' },
    paymentMode: { id: 'PaymentModeID', name: 'PaymentMode' },
    city: { id: 'PartyCityId', name: 'PartyCity' },
    party: { id: 'PartyID', name: 'Partyname' },
  }
  const setFilters = (list) => {
    const acc = Object.keys(filterConfig).reduce((o, key) => {
      o[key] = new Map()
      return o
    }, {})

    list.forEach((item) => {
      Object.entries(filterConfig).forEach(([key, cfg]) => {
        const id = item[cfg.id]
        const name = item[cfg.name]

        if (id != null && !acc[key].has(id)) {
          acc[key].set(id, { id, name })
        }
      })
    })

    const bookingTypeList = [...acc.bookingType.values()]
      .map((item) => {
        if (UseToPayAsCOD === 1) {
          if (item.id === 4) {
            return false
          }
          return { ...item, name: TOPAY_COD_RULE[item.id] || item.name }
        }
        return item
      })
      .filter(Boolean)
    if (bookingTypeList.length > 1) {
      bookingTypeList.unshift({ id: 0, name: 'All' })
    }

    const paymentModeList = [...acc.paymentMode.values()]
    if (paymentModeList.length > 1) {
      paymentModeList.unshift({ id: 0, name: 'All' })
    }

    const cityList = [...acc.city.values()]
    if (cityList.length > 1) {
      cityList.unshift({ id: 0, name: 'All' })
    }

    const partyList = [...acc.party.values()]
    if (partyList.length > 1) {
      partyList.unshift({ id: 0, name: 'All' })
    }

    setBookingTypeDropdown(bookingTypeList)
    if (bookingTypeList.length) {
      setBookingMode(bookingTypeList[0])
    }

    setPymtModeDropdown(paymentModeList)
    if (paymentModeList.length) {
      setPaymentMode(paymentModeList[0])
    }

    setCityDropdown(cityList)
    if (enableBranchChange) {
      const cityObj = {
        id: intBranchCityID,
        name: strCityName,
      }
      setPartyCity(cityObj)
    } else if (cityList.length) {
      setPartyCity(cityList[0])
    }

    setPartyDropdown(partyList)
    if (partyList.length) {
      setParty(partyList[0])
    }
  }
  const handleClickGo = () => {
    if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      setAlert({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else {
      const obj = {
        intCompanyID: intCompanyID,
        intBranchID: intBranchID,
        intUserID: intUserID,
        dtFromDate: fromDate.format('YYYY-MM-DD'),
        dtToDate: toDate.format('YYYY-MM-DD'),
      }
      setLoader(true)
      GetRequest(urls.getPartyBookingReportFilter, obj)
        .then((res) => {
          if (res.status !== 'Success' || !Array.isArray(res.Data.Table)) {
            throw new Error(res?.ErrMessage || 'Invalid Response')
          }
          if (!res.Data.Table.length) {
            throw new Error('No Data Found')
          }
          setFilters(res.Data.Table)
        })
        .catch((err) => {
          setAlert({ show: true, msg: err.message, nextId: '' })
        })
        .finally(() => {
          setLoader(false)
        })
    }
  }
  const handleClick1 = (isPdf = false) => {
    const diffDays = Math.abs(toDate.diff(fromDate, 'days'))
    const isAllSelected = partyCity?.id === 0 || party?.id === 0
    if (isAllSelected && diffDays > 15) {
      dispatch(updateAlertError({ show: true, msg: 'For All selection, date range cannot exceed 15 days', nextId: '' }))
    } else if (!isAllSelected && diffDays > 31) {
      dispatch(updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' }))
    } else {
      setIsExpanded(true)
      let object = {
        DateFrom: fromDate.format('YYYY-MM-DD'),
        DateTo: toDate.format('YYYY-MM-DD'),
        CompanyID: intCompanyID,
        BranchId: intBranchID,
        PartyasId: partyAsId,
        PartyId: party?.id || 0,
        BookingModes: bookingMode?.id || 0,
        PaymentMode: paymentMode?.id || 0,
        PartyCity: partyCity?.id || 0,
      }
      setLoader(true)
      GetRequest(urls.getPartyBookingData, object)
        .then((res) => {
          if (res.status !== 'Success' || !Array.isArray(res.Data.Table)) {
            throw new Error(res?.ErrMessage || 'Invalid Response')
          }
          if (!res.Data.Table.length) {
            throw new Error('No Data')
          }
          let responseData = res.Data

          responseData = {
            ...responseData,
            Table: responseData.Table.map((item) => ({
              ...item,
              PayType: UseToPayAsCOD === 1 ? TOPAY_COD_RULE2[item.PayType] || item.PayType : item.PayType,
              BookingDate: moment(item?.BookingDateTime).format('DD-MMM-YY'),
              BookingTime: moment(item?.BookingDateTime).format('hh:mm A'),
            })),
          }
          
          let headers = []
          let processedData = []
          let reportPayload = {}
          if (reportView?.id === 0) {
            headers = manageColumn
              .map((a) => ({
                ...a,
                field: a.dataKey,
                align: a.xlCol.dataType === "quantity" ? "right" : "left",
                width: getInt(a.minWidth),
                weight: 80
              }))
            const newList = responseData.Table.map((item) => ({
              ...item,
              ...buildCompositeFields(item, headers),
            }))
            processedData = groupDataDetailed(newList, headers, intCompanyID)
            const summaryData = isGajraj ? transformPartyBookingSummary(responseData.Table) : null

            reportPayload = isGajraj ? {
              reportName,
              isMultiTable: true,
              isShowManageColumn: true,
              manageColumnID: "partyReportDetailed",
              tables: [
                {
                  criteriaHeaders,
                  criteriaData: [criteriaData],
                  tableData: processedData,
                  mainHeader: headers,
                  serialNokey: 'SN',
                  colSpanMarker: 'SN',
                  isInvoiceRedirect: true,
                  isWrapEntryText: true,
                  isClampHeaderToTwoLines: true,
                  enableHorizontalScroll: true,
                },
                {
                  tableData: summaryData,
                  mainHeader: partyBookingSummaryHeader,
                  serialNokey: 'SN',
                }
              ],
            } : {
              reportName,
              criteriaHeaders,
              criteriaData: [criteriaData],
              tableData: processedData,
              mainHeader: headers,
              isShowManageColumn: true,
              manageColumnID: "partyReportDetailed",
              isInvoiceRedirect: true,
              colSpanMarker: 'STATUS',
              serialNokey:'SN'
            }
            if (isPdf === true) {
              if (isGajraj) {
                downloadMultiTablePDF({
                  reportName,
                  criteriaHeaders,
                  criteriaData: [criteriaData],
                  tables: [
                    {
                      tableData: processedData,
                      visibleColumns: headers,
                      hideHeader: false,
                    },
                    {
                      tableData: summaryData,
                      visibleColumns: partyBookingSummaryHeader,
                      hideHeader: false,
                    },
                  ],
                  loginData,
                })
              } else {
                downloadPDF({
                  reportName,
                  criteriaHeaders,
                  criteriaData: [criteriaData],
                  tableData: processedData,
                  visibleColumns: headers,
                  loginData,
                  hideHeader: false
                })
              }
              return
            }
          } else {
            headers = summaryTblColDefs.map((a) => ({
              ...a,
              field: a.dataKey,
              align: a.xlCol.dataType === "quantity" ? "right" : "left",
              width: getInt(a.minWidth),
              weight: 80
            }))
            processedData = groupDataDetailedSummary(
              responseData.Table1,
              responseData.Table2,
              partyAsId,
              headers
            )
            reportPayload = {
              reportName,
              criteriaHeaders,
              criteriaData: [criteriaData],
              tableData: processedData,
              mainHeader: headers,
              serialNokey:'SN'
            }
            if (isPdf === true) {
              downloadPDF({
                reportName,
                criteriaHeaders,
                criteriaData: [criteriaData],
                tableData: processedData,
                visibleColumns: headers,
                loginData,
                hideHeader: false
              })
              return
            }
          }
          const rid = Date.now().toString()
          if (!window.generatedReports) {
            window.generatedReports = {}
          }
          window.generatedReports[rid] = reportPayload
          window.open(`/view-report?rid=${rid}`, "_blank")
        })
        .catch((error) => {
          setAlert({ show: true, msg: error.message, nextId: '' })
        })
        .finally(() => {
          setLoader(false)
        })
    }
  }
  const handleClick2 = () => {
    let url = urls2.partyBookingReport
    const urlData = urls2.partyBookingReportParams
    urlData.chk = loginData.BusCrsCheckSum
    urlData.FromDate = fromDate.format('YYYY-MM-DD')
    urlData.ToDate = toDate.format('YYYY-MM-DD')
    urlData.CompanyId = intCompanyID
    urlData.BranchId = intBranchID
    urlData.PartyAsId = partyAsId
    urlData.PartyId = party?.id || 0
    urlData.BookingMode = bookingMode?.id || 0
    urlData.PaymentMode = paymentMode?.id || 0
    urlData.PartyCity = partyCity?.id || 0
    urlData.mode = reportView?.id ? reportView?.id : 0
    urlData.PartyName = party?.name || ''
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }

  const resetFilters = () => {
    setResetFilter(!resetFilter)
    setFromDate(moment(new Date()))
    setToDate(moment(new Date()))
    setPartyCity('')
    setParty('')
    setPaymentMode('')
    setPartyAsId(0)
    setReportView('')
    setIsExpanded(false)
  }


  document.addEventListener('keydown', function (event) {
    const key = event.key.toLocaleLowerCase()
    if (event.altKey && key === 'r') {
      clickElement('partyRefreshBtn')
    } else if (event.altKey && key === 'q') {
      document.getElementById('prtyBkngFromDate').focus()
    }
  })
  const onSaveColumns = (headers) => {
    setManageColumn(headers)
    localStorage.setItem('partyReportDetailed', JSON.stringify(headers))
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        {isFromUrl && <style>{`.global-header { display: none; } #root { zoom: 1.2; }`}</style>}
        {!isFromUrl && <ReportHeading reportName={reportName} />}
        <Box sx={!isFromUrl ? { ...sx.reportFlex, flexWrap: 'nowrap' } : { ...sx.reportFlex, justifyContent: 'start', gap: '15px' }}>
          {!isFromUrl && <>
            <Item sx={sx.itemsx} style={{ width: '14.6%' }}>
              <DropDownOA
                id={'prtyBkngCompanyName'}
                label={'Company Name'}
                width="100%"
                searchPlaceholder={'Search Company Name'}
                disabled
                onSelect={(e) => {
                  setIsExpanded(false)
                }}
                nextId="prtyBkngGoBtn"
                prevId=""
                resetFlag={resetFilter}
                data={companyDropdown || []}
                defaultvalue={companyName || ''}
                value={companyName || ''}
                dataKey={`name`}
                idKey={`id`}
              />
            </Item>
            <Item sx={sx.itemsx}>
              <Button
                variant="contained"
                id="prtyBkngGoBtnOne"
                style={{ ...sx.fullHeight, ...sx.novp }}
                className="btn btn-primary"
                disabled
              >
                GO
              </Button>
            </Item>
          </>}
          <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker" style={{ width: isFromUrl ? '100%' : '14%' }}>
            <Datepicker
              label={`From Booking Date`}
              id="prtyBkngFromDate"
              width="100%"
              value={fromDate}
              dateChange={(date) => {
                setFromDate(date)
                setIsExpanded(false)
                focusElemnt('prtyBkngToDate')
              }}
            />
          </Item>
          <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', gap: '10px', width: isFromUrl ? '100%' : 'auto' }}>
            <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker" style={{ width: isFromUrl ? '100%' : '14%' }}>
              <Datepicker
                label={'To Booking Date'}
                id="prtyBkngToDate"
                value={toDate}
                dateChange={(date) => {
                  setToDate(date)
                  setIsExpanded(false)
                  focusElemnt('prtyBkngGoBtnTwo')
                }}
                width="100%"
              />
            </Item>
            <Item sx={sx.itemsx}>
              <Button
                variant="contained"
                id="prtyBkngGoBtnTwo"
                style={{ ...sx.fullHeight, ...sx.novp }}
                className="btn btn-primary"
                onClick={handleClickGo}
                onKeyDown={(e) => navigation3(e, 'prtyBkngPymtMode', 'prtyBkngToDate', () => handleClickGo())}
              >
                GO
              </Button>
            </Item>
          </Box>
          <Item sx={isFromUrl ? sx.itemsxGrow : { ...sx.itemsx, width: '14%' }}>
            <DropDownOA
              id="prtyBkngPymtMode"
              label={'Payment Mode'}
              data={pymtModeDropdown || []}
              defaultvalue={paymentMode?.name || ''}
              value={paymentMode?.name || ''}
              width="100%"
              searchPlaceholder={'Search Payment Mode'}
              dataKey={`name`}
              idKey={`id`}
              resetFlag={resetFilter}
              onSelect={(e) => {
                setPaymentMode(e)
                setIsExpanded(false)
              }}
              nextId="prtyBkngPymtType"
              prevId="prtyBkngGoBtnTwo"
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : { ...sx.itemsx, width: '14%' }}>
            <DropDownOA
              id="prtyBkngPymtType"
              label={'Payment Type'}
              data={bookingTypeDropdown || []}
              width="100%"
              searchPlaceholder={'Search Payment Type'}
              dataKey={`name`}
              defaultvalue={bookingMode?.name || ''}
              value={bookingMode?.name || ''}
              idKey={`id`}
              onSelect={setBookingMode}
              nextId="prtyBkngCityId"
              prevId="prtyBkngPymtMode"
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : { ...sx.itemsx, width: '14%' }}>
            <DropDownOA
              id="prtyBkngCityId"
              label={'Select City'}
              data={cityDropdown || []}
              width="100%"
              defaultvalue={partyCity?.name || ''}
              value={partyCity?.name || ''}
              searchPlaceholder={`Search City Name`}
              dataKey={`name`}
              idKey={`id`}
              resetFlag={resetFilter}
              onSelect={(e) => {
                setPartyCity(e)
                setIsExpanded(false)
              }}
              disabled={!enableBranchChange}
              nextId="prtyBkngParty"
              prevId="prtyBkngPymtType"
            />
          </Item>
        </Box>
        <Box sx={!isFromUrl ? { ...sx.reportFlex, flexWrap: 'nowrap' } : { ...sx.reportFlex, justifyContent: 'start', gap: '15px' }}>
          <Item sx={isFromUrl ? sx.itemsxGrow : { ...sx.itemsx, width: '14.6%' }}>
            <DropDownOA
              id="prtyBkngParty"
              label={'Select Party'}
              data={partyDropdown || []}
              width="100%"
              searchPlaceholder={`Search Party Name`}
              dataKey={`name`}
              idKey={`id`}
              defaultvalue={party?.name || ''}
              value={party?.name || ''}
              resetFlag={resetFilter}
              onSelect={(e) => {
                setParty(e)
                setIsExpanded(false)
              }}
              nextId="prtyBkngPartyAS"
              prevId="prtyBkngCityId"
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : { ...sx.itemsx, width: '19.85%' }}>
            <DropDownOA
              id="prtyBkngPartyAS"
              label={'Party As'}
              data={partyAsList || []}
              defaultvalue={partyAsList[partyAsId].name}
              value={partyAsList[partyAsId].name}
              width="100%"
              searchPlaceholder={`Search Party Name`}
              dataKey={`name`}
              idKey={`id`}
              listWidth="200px"
              resetFlag={resetFilter}
              onSelect={(e) => {
                setPartyAsId(e.id)
                setIsExpanded(false)
              }}
              nextId="prtyBkngReportView"
              prevId="prtyBkngParty"
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : { ...sx.itemsx, width: '14%' }}>
            <DropDownOA
              id="prtyBkngReportView"
              defaultvalue={reportView?.name}
              value={reportView?.name}
              data={reportViewList || []}
              width="100%"
              searchPlaceholder={`Search By View`}
              label={'Report View'}
              tabIndex="2"
              dataKey={`name`}
              idKey={`id`}
              resetFlag={resetFilter}
              onSelect={(value) => {
                setReportView(value)
                setIsExpanded(false)
              }}
              nextId="prtyBkngSplitBtn"
              prevId="prtyBkngPartyAS"
            />
          </Item>
          {isFromUrl ?
            <Button variant="contained" sx={{ width: '100%', height: '40px' }} className="btn btn-primary" onClick={() => handleClick1(true)} id1={'prtyBkngSplitBtn'}>
              DOWNLOAD PDF
            </Button> :
            <>
              <Item
                sx={sx.itemsx}
                tabIndex={0}
                onKeyDown={(e) =>
                  navigation3(
                    e,
                    isExpanded
                      ? AllowExportExcel === 1
                        ? 'test-table-xls-button'
                        : 'exportAsPdfBtn'
                      : 'prtyBkngFromDate',
                    'prtyBkngReportView',
                    () => handleClick1()
                  )
                }
              >
                <SplitButton
                  options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                  hideToggle={false}
                  id1="prtyBkngSplitBtn"
                  onClick1={() => {
                    handleClick1()
                  }}
                  onClick2={handleClick2}
                />
              </Item>
              <Item
                sx={{ ...sx.itemsx }}
                id="partyRefreshBtn"
                onClick={() => {
                  resetFilters()
                }}
              >
                <RefreshSvg />
              </Item>
            </>}
        </Box>
      </Item>
      {mdt.DetailedPartyBookingmodal === modal ? (
        <ManageColumns headers={manageColumn} onSave={onSaveColumns} updateModal={setModal} />
      ) : (
        <></>
      )}
    </>
  )
}
export default PartyBookingReport